export const isLearningObject = (obj) => obj.object_type === 'learning_object' || obj.type === 'LearningObject'
export const isCommunityCollection = (obj) => obj.object_type === 'community_collection'
  || obj.type === 'CommunityCollection'
export const isCareerCollection = (obj) => obj.object_type === 'career_collection' || obj.type === 'CareerCollection'
